import { Component, OnInit, OnDestroy, HostListener, HostBinding, ElementRef, Input, AfterViewInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { KeyboardService } from '../keyboard.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.css']
})
export class KeyboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostBinding('class.shown')
  private shown: boolean;
  @Input() tipoTeclado: any  = {
    numerico: false,
    alpha: true
  };
  private keyboardSubscription: Subscription;
  alphaKeysActive: boolean = true;
  symbolKeysActive: boolean = false;
  capsActive: boolean = false;

  constructor(private el: ElementRef,  public keyboard: KeyboardService) {
  }

  ngOnInit() {
    this.keyboardSubscription = this.keyboard.keyboardRequested.subscribe(show => {
      this.shown = !show;
    });
  }
  ngAfterViewInit() {}

  ngOnDestroy() {
    this.keyboardSubscription.unsubscribe();
  }

  onShift() {
    this.keyboard.shift = !this.keyboard.shift;
  }


  onAlt() {
    this.keyboard.alt = !this.keyboard.alt;
    this.keyboard.shift = false;
  }

  onBackspace() {
    this.keyboard.fireBackspacePressed();
  }

  onEnter() {
    this.keyboard.fireEnterPressed();
  }

  mudarTeclas(){
   this.symbolKeysActive = !this.symbolKeysActive;
   this.alphaKeysActive = !this.alphaKeysActive;
  }
  @HostListener('mousedown', ['$event'])
  @HostListener('click', ['$event'])
  onMouseEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
